module.exports = __webpack_public_path__ + "static/media/vibinoLogoC.04b9c558.svg";